import type { ComponentType, ReactNode } from "react";
import { OpenAiAdsInit } from "./init";
import type { OpenAiAdsApp } from "./pixel-ids";

type ScriptComponentProps = {
  id?: string;
  children?: ReactNode;
};

const HtmlScript = ({ id, children }: ScriptComponentProps) => (
  <script id={id}>{children}</script>
);

// Bootstraps window.oaiq as a call queue and lazily loads the pixel SDK. Actual oaiq
// calls (init, measure) go through initOpenAiAdsPixel/trackOpenAiAdsConversion in track.ts.
const OAIQ_LOADER_SCRIPT = `
  (function (w, d, s, u) {
    if (w.oaiq) return;
    var q = function () {
      q.q.push(arguments);
    };
    q.q = [];
    w.oaiq = q;
    var js = d.createElement(s);
    js.async = true;
    js.src = u;
    var f = d.getElementsByTagName(s)[0];
    f.parentNode.insertBefore(js, f);
  })(window, document, "script", "https://bzrcdn.openai.com/sdk/oaiq.min.js");
`;

type Props = {
  app: OpenAiAdsApp;
  // Defaults to a plain <script> tag; pass next/script's `Script` to get its loading strategies instead.
  component?: ComponentType<ScriptComponentProps>;
};

/**
 * Installs the OpenAI Ads Measurement Pixel SDK and initializes it with the app's pixel ID.
 * Render once in the layout/page for any route tree that needs OpenAI Ads conversion tracking.
 */
export const OpenAiAdsScript = ({
  app,
  component: ScriptComponent = HtmlScript,
}: Props) => (
  <>
    <ScriptComponent id="openai-ads-pixel">{OAIQ_LOADER_SCRIPT}</ScriptComponent>
    <OpenAiAdsInit app={app} />
  </>
);

